export const Marquee = ({ text = "Real moments · Analog memories", className = "" }) => {
  const item = (
    <span className="font-serif italic text-cream/90 text-3xl sm:text-5xl px-8 whitespace-nowrap">
      {text} <span className="not-italic font-sans text-cream/40 mx-2">✳</span>
    </span>
  );
  return (
    <div className={`overflow-hidden bg-forest py-5 ${className}`} aria-hidden="true">
      <div className="flex w-max marquee-track">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex">{item}</div>
        ))}
      </div>
    </div>
  );
};
